/* TOPIC DETAILS */
export const TOPIC_DETAILS_FETCH_REQUEST = "TOPIC_DETAILS_FETCH_REQUEST";
export const TOPIC_DETAILS_FETCH_SUCCESS = "TOPIC_DETAILS_FETCH_SUCCESS";
export const TOPIC_DETAILS_FETCH_FAILURE = "TOPIC_DETAILS_FETCH_FAILURE";

export const UPDATE_TOPIC_FOLLOW_STATUS = 'UPDATE_TOPIC_FOLLOW_STATUS';
